import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  getConsent,
  setConsent,
  onConsentOpenRequest,
} from "../utils/cookieConsent";

const CookieConsent: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      setIsVisible(true);
    }
    return onConsentOpenRequest(() => setIsVisible(true));
  }, []);

  const handleChoice = (value: "all" | "necessary") => {
    setConsent(value);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        {t("cookieConsent.pre")}
        <a style={styles.link} href="/datenschutz">
          {t("cookieConsent.linkText")}
        </a>
        {t("cookieConsent.post")}
      </p>
      <div style={styles.buttons}>
        <button
          style={styles.secondaryButton}
          onClick={() => handleChoice("necessary")}
        >
          {t("cookieConsent.necessary")}
        </button>
        <button
          style={styles.primaryButton}
          onClick={() => handleChoice("all")}
        >
          {t("cookieConsent.all")}
        </button>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed" as const,
    bottom: 0,
    left: 0,
    width: "100%",
    boxSizing: "border-box" as const,
    backgroundColor: "#333",
    color: "#fff",
    padding: "1em",
    display: "flex" as const,
    flexWrap: "wrap" as const,
    alignItems: "center",
    justifyContent: "center",
    gap: "1em",
    zIndex: 1000,
  },
  text: {
    margin: 0,
    maxWidth: "48rem",
    flex: "1 1 30rem",
  },
  buttons: {
    display: "flex" as const,
    gap: "0.75em",
    flexShrink: 0,
  },
  primaryButton: {
    padding: "0.6em 1.2em",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "0.4em",
    cursor: "pointer",
  },
  secondaryButton: {
    padding: "0.6em 1.2em",
    backgroundColor: "transparent",
    color: "#fff",
    border: "0.1em solid #fff",
    borderRadius: "0.4em",
    cursor: "pointer",
  },
  link: {
    color: "#fff",
    textDecoration: "underline",
  },
};

export default CookieConsent;
